import ReactGA from 'react-ga';
import { isDevelopment } from './EnvHelper';
export const sendEvent = (category: string, action: string) => {
  if (!isDevelopment) {
    ReactGA.event({
      category,
      action,
    });
  }
};
